import {XauditModel} from '../xaudit.model';
export class dataPatientCaseWorkItemEventModel extends XauditModel {
    WorkItemEventId: string;
    PatientCaseId: string;
    CaseWorkItemId: string;
    LOCID: number;
    enumWorkItemEventTypeID: string;
    EventDateStart: Date;
    EventDateFinish: Date;
    ProviderDoctorContactID: string;
    OriginAppointmentId: string;
    ProviderDoctorId: string;
}
